<template>
    <div class="mb-5 recommend-product"  ref="recommendContainer" v-if="currentShow">
        <div class="container">
            <div class="title-line" v-if="!isLoading">
                <h4 class="title-text" v-text="title"></h4>
                <a href="product" class="title-button btn btn-lg more" role="button" aria-pressed="true" title="">更多產品</a>
            </div>
            <div class="spinner-border text-primary" role="status" v-if="isLoading">
                <span class="sr-only">Loading...</span>
            </div>
            <div class="row" v-if="!isLoading">
                    <div class="col-lg-3 col-md-4 col-6 mb-4" v-for="item in recommends" :key="item.id">
                        <product-component
                            :name="item.name"
                            :product-id="item.id"
                            :slug="item.slug"
                            :pic-url="item.Pics[0]?.url['w0h0']"
                            :min-price="item.minPrice"
                            :favorite-added="item.favoriteAdded ? true : false"
                            :sku="item.productNumber"
                            :category="item.textClassMetas"
                            :preorder-active="item.ProductField?.preorderActive ? true : false"
                            :preorder-to-date="item.ProductField.preorderToDate"
                            :preorder-from-date="item.ProductField.preorderFromDate"
                            :type-id-spec-id-key="item.typeIdSpecIdKey"
                            :rating="item.ratingsAvgRating"
                            :rating-count="item.ratingsCount"
                        ></product-component>
                    </div>
                </div>
        </div>
    </div>
</template>
<script>
import ProductComponent from 'Vue/Web/Shop/Product/ProductComponent.vue';

export default {
    name: 'HomePageProductComponent',
    components: {
        ProductComponent,
    },
    props: {
        ids: {
            type: String,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: '',
        },
        title: {
            type: String,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: '推薦產品',
        },
        show: {
            type: Boolean,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: false,
        },
        url: {
            type: String,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: '/api/recommendProduct',
        },
    },
    data() {
        return {
            currentShow: false,
            isLoading: true,
            recommends: [],
        };
    },
    beforeMount() {
        this.currentShow = !!(this.ids || this.show);
    },
    mounted() {
        this.setupIntersectionObserver();
    },
    computed: {},
    methods: {
        setupIntersectionObserver() {
            const options = {
                root: null, // 代表 viewport
                threshold: 0.2, // 當元素進入到 20% 的範圍時觸發
            };

            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting && this.currentShow) {
                        this.getResult();
                        observer.unobserve(this.$refs.recommendContainer); // 只觸發一次，然後停止觀察
                    }
                });
            }, options);

            if (this.$refs.recommendContainer) {
                observer.observe(this.$refs.recommendContainer);
            }
        },
        initOwlCarousel() {
            $(this.$refs.carousel)
                .owlCarousel({
                    autoplay: false, // 自動撥放
                    loop: false, // 圖片循環
                    center: false, // 是否置中
                    navText: [], // 箭頭預設文字消失
                    nav: true, // 前後箭頭
                    dot: true,
                    responsive: {
                        0: {
                            items: 1,
                        },
                        480: {
                            items: 2,
                        },
                        768: {
                            items: 3,
                        },
                        1024: {
                            items: 4,
                        },
                    },
                });
        },
        formatDate(dateString) {
            const options = {
                month: 'short',
                day: '2-digit',
                year: 'numeric',
            };
            const date = new Date(dateString);
            return date.toLocaleDateString('en-US', options);
        },
        async getResult() {
            let response;
            try {
                response = await axios.get(`${this.url}/${this.ids}`);
                this.recommends = response.data.data;
                this.isLoading = false;

                // 等待 DOM 完全更新後再初始化 OwlCarousel
                this.$nextTick(() => {
                    // this.initOwlCarousel();
                });
            } catch (error) {
                console.log(error);
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.spinner-border {
    margin: 0 50%;
}
$maincolor: #72ca4a;
$smallstandard:#555;
%color-button {
    border: 1px solid $maincolor;
    color: $maincolor;
    background: transparent;
    padding: 0.75rem 3rem;
    font-size: 1.25rem;
    position: relative;
    @media (min-width: 1025px) {
        font-size: 1rem;
    }
    @media (min-width: 480px) {
        color: white;
        background: $maincolor;
    }
    &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 0;
        background: $maincolor;
        transition: 0.3s linear;
        z-index: -1;
    }
    &:hover {
        color: white;
        transition: 0.4s;
        &::after {
            width: 100%;
            transition: 0.3s linear;
        }
    }
}
%title {
    display: flex;
    align-items: center;
    margin-bottom: 1.5rem;
    .title-text {
        flex: 1;
        margin-bottom: 0;
    }
    .title-button {
        color: $smallstandard;
        position: relative;
        transition: 0.4s; // background: transparent;
        padding: 0;
        @media (max-width: 1367px) {
            font-size: 12px;
        }
        &::after {
            content: '';
            position: absolute;
            width: 100%;
            height: 1px;
            bottom: 0;
            left: 0;
            transition: 0.3s linear;
            background: $maincolor;
        }
        &:hover {
            transition: 0.4s;
            color: $maincolor;
            &::after {
                width: 100%;
                background: $maincolor;
                transition: 0.3s linear;
            }
        }
    }
}
.recommend-product {
    margin-top: 2rem;
    .title-line {
        @extend %title;
    }
    .read-button {
        @extend %color-button;
    }
}
</style>
